import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { ChallengeService } from '@duck/api-definitions'
import { workspaceTabsDefinitions } from '@/components/WorkspaceTabs/workspaceTabs.definitions'
import { workspaceChallengeAtom, workspaceTaskAtom } from '@/store/workspaceAtoms'

const SQL_ONLY_TABS = new Set<ChallengeService.WorkspaceTabTypeEnum>([
  ChallengeService.WorkspaceTabTypeEnum.Sql,
  ChallengeService.WorkspaceTabTypeEnum.Solution,
  ChallengeService.WorkspaceTabTypeEnum.SqlCheatSheet,
])

/**
 * Source of truth for which workspace tab types are renderable in the current session.
 * Filters out types without a definition (e.g. removed enum values still present in
 * persisted workState) and tabs that don't match the chosen weapon.
 */
export const useAvailableWorkspaceTabs = (): Set<ChallengeService.WorkspaceTabTypeEnum> => {
  const challenge = useAtomValue(workspaceChallengeAtom)
  const task = useAtomValue(workspaceTaskAtom)

  const chosenWeapon: ChallengeService.TaskWeaponsOfChoiceEnum =
    challenge?.workState?.chosenWeapon ??
    task?.allowedWeapons?.[0] ??
    ChallengeService.TaskWeaponsOfChoiceEnum.Sql

  return useMemo(() => {
    const allowed = new Set<ChallengeService.WorkspaceTabTypeEnum>()
    const isPython = chosenWeapon === ChallengeService.TaskWeaponsOfChoiceEnum.Python
    const knownTypes = new Set<string>(Object.values(ChallengeService.WorkspaceTabTypeEnum))
    for (const key of Object.keys(workspaceTabsDefinitions)) {
      if (!knownTypes.has(key)) continue
      const type = key as ChallengeService.WorkspaceTabTypeEnum
      if (type === ChallengeService.WorkspaceTabTypeEnum.Python) {
        if (!isPython) continue
      } else if (SQL_ONLY_TABS.has(type) && isPython) {
        continue
      }
      allowed.add(type)
    }
    return allowed
  }, [chosenWeapon])
}
